
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { FilterableMasterSelectableMixin, StandardOption } from "../../../system/selectors/mixins";
import { DomainRegistry } from "../../../../domain";
import { Department, DepartmentGroup } from "../../../../domain/department";
import Enumerable from "linq";

@Component({
})
export default class DepartmentSelectableMixin extends Mixins(FilterableMasterSelectableMixin) {
  values: Department[];

  created() {
    const repository = DomainRegistry.department.getDepartmentRepository();
    repository.getAllEntities()
      .then(e => this.values = e)
      .catch(e => {
        this.$error(
          this.$wording.common.department + "情報取得失敗",
          this.$wording.common.department + "情報を取得できませんでした。",
          e,
        );
      });
  }

  @Prop()
  departmentGroup: DepartmentGroup;

  @Prop()
  shouldShowReferenceableGroupDepartments: boolean;

  get departmentOptions(): StandardOption<Department>[] {
    if (this.$store.getters.isDepartmentGroupScopeEnable) {
      if (this.isReferenceableGroup(this.departmentGroup)) {
        return Enumerable.from(this.options).where(o => Enumerable.from(this.departmentGroup.departments).any(d => d.id === o.value.id)).toArray();
      }
      const referenceableDepartmentGroups = this.$store.getters.referenceableDepartmentGroups as DepartmentGroup[];
      const groups = this.shouldShowReferenceableGroupDepartments
        ? referenceableDepartmentGroups.concat()
        : [];
      const loginDepartmentGroup = this.$store.getters.departmentGroup as DepartmentGroup;
      if (loginDepartmentGroup) {
        groups.push(loginDepartmentGroup);
      }
      const referenceableDepartmentCodes = Enumerable.from(groups)
        .selectMany(g => g.departments)
        .select(d => d.id)
        .distinct()
        .toArray();
      return Enumerable.from(this.options).where(o => referenceableDepartmentCodes.some(code => code === o.value.id)).toArray();
    }
    const departmentGroup = (this.departmentGroup === undefined)
      ? (this.$configuration.behavior.departmentGroup.feature.isEnable ? this.$store.getters.departmentGroup as DepartmentGroup : null)
      : this.departmentGroup;
    return !!departmentGroup
      ? Enumerable.from(this.options).where(o => Enumerable.from(departmentGroup.departments).any(d => d.id === o.value.id)).toArray()
      : this.options;
  }

  private isReferenceableGroup(departmentGroup: DepartmentGroup): boolean {
    if (!departmentGroup) { return false; }
    const loginDepartmentGroup = this.$store.getters.departmentGroup as DepartmentGroup;
    if (loginDepartmentGroup && loginDepartmentGroup.id === departmentGroup.id) { return true; }

    if (!this.shouldShowReferenceableGroupDepartments) { return false; }
    const referenceableDepartmentGroups = this.$store.getters.referenceableDepartmentGroups as DepartmentGroup[];
    return referenceableDepartmentGroups.some(g => g.id === departmentGroup.id);
  }

  @Watch("departmentOptions")
  onDepartmentOptionsUpdated(newOptions: StandardOption<Department>[]) {
    this.$nextTick(() => {
      if (newOptions && this.editingSource && Enumerable.from(newOptions).all(o => o.value.id !== this.editingSource.id)) {
        this.$logger.debug("診療科の選択残りをクリアします。Id=" + this.editingSource.id);
        this.editingSource = null;
      }
    });
  }
}
